import React, { Component, Fragment } from 'react';
import Stepper from '../../shared/Stepper';
import RemoteTeleshoppingErrors from './RemoteTeleshoppingErrors';
import { Route } from 'react-router-dom';
import ActivityIndicator from '../../shared/ActivityIndicator';
import { generateRoutes, getSteps, getRoutes, goBack } from '../../../helpers/stepperFunctions';

class RemoteTeleshopping extends Component {
  state = {
    persisted: false,
    routeList: []
  };

  async componentDidMount() {
    const process = 'remoteTeleshopping';

    if (this.props.location.pathname.includes('contract-validation')) {
      await this.props.clearTeleshopping()
      await this.props.resetStepper();
      this.tryGetProcessAndSetRoutes(process);
    } else {
      this.props.persistTeleshopping();
      this.props.persistStepper();
    }
  }
  componentDidUpdate = () => {
    if (
      !this.state.persisted &&
      !this.props.location.pathname.includes('contract-validation')
    ) {
      this.tryGetProcessAndSetRoutes(this.props.process);
    }
  };

  tryGetProcessAndSetRoutes = process => {
    const globalSettings = {
      validateSaleInvoices: null,
      validatePromissoryInvoices: null
    };
    if (process) {
      const routeList = generateRoutes(process, globalSettings);
      this.props.setSteps(getSteps(routeList), getRoutes(routeList), process);
      this.setState({ routeList, persisted: true });
    }
  };
  _renderStep = () => {
    const { location, remoteTeleshoppingCompleted, routes, skips } = this.props;
    const currentStep = routes.indexOf(location.pathname);
    const maxStep = this.props[`${this.props.process}Next`];
    const route = this.state.routeList.find(
      route => route.path === location.pathname
    );

    if (currentStep >= 0 && maxStep >= 0 && route) {
      if (
        currentStep <= maxStep ||
        (remoteTeleshoppingCompleted &&
          location.pathname === '/remote-teleshopping/register')
      ) {
        return (
          <Fragment>
            <Stepper />
            <Route
              exact
              path={route.path}
              render={props => (
                <route.component
                  {...props}
                  goBack={() => goBack(routes, skips, location.pathname)}
                />
              )}
            />
          </Fragment>
        );
      } else {
        this.props.history.push(this.props.routes[maxStep]);
        this.props.newAlert(
          'error',
          'ERROR:',
          'No puedes ingresar a este paso sin haber completado los anteriores.'
        );
      }
    } else {
      this.props.newAlert(
        'error',
        'ERROR:',
        'La ruta ingresada no existe en el registro de venta.'
      );
    }
  };

  render() {
    const {
      location,
      server_errors,
      baseErrorOpen,
      baseErrorText,
      baseErrorTitle,
      baseErrorRoute,
      toggleBaseErrorModal,
      toggleBaseErrorModalTeleshopping,
      loadingParameters
    } = this.props;
    if (loadingParameters && location.pathname.includes('contract-validation'))
      return <ActivityIndicator />;
    if (!this.state.persisted) return null;
    return (
      <Fragment>
        <RemoteTeleshoppingErrors
          server_errors={server_errors}
          baseErrorOpen={baseErrorOpen}
          baseErrorText={baseErrorText}
          baseErrorTitle={baseErrorTitle}
          toggleModal={toggleBaseErrorModal}
          toggleModalTS={toggleBaseErrorModalTeleshopping}
          baseErrorRoute={baseErrorRoute}
        />
        {this._renderStep()}
      </Fragment>
    );
  }
}

export default RemoteTeleshopping;
